import { useModal } from 'modals';
import GreenLink from 'components/GreenLink';
import SectionHeader from 'components/SectionHeader';

export default function PipelineIntegrationSection() {
  const { open } = useModal();
  return (
    <section className="py-(--vertical-spacing)">
      <div className="container">
        <SectionHeader
          title="Evaluate Cartwheel in your motion pipeline"
          description="Discover how Cartwheel can integrate directly into your existing workflow, delivering scaled-up motion generation and iteration with zero disruption."
        />

        <div className="mt-4 flex flex-col gap-4 lg:mt-8 lg:gap-6">
          <GreenLink
            onClick={() =>
              open('ENTERPRISE_CONTACT', { reason: 'pilot_cartwheel' })
            }
          >
            Pilot Cartwheel
          </GreenLink>
          <GreenLink
            onClick={() =>
              open('ENTERPRISE_CONTACT', { reason: 'request_api_access' })
            }
          >
            Request API Access
          </GreenLink>
        </div>
      </div>
    </section>
  );
}
